import { StoryblokComponent } from '@storyblok/react';

import { JsonObject } from '../../../types/jsonObject';
import { ServiceOSApiClient } from '../../../utils/serviceOSApiClient';
import { FormBuilderRequestLifecycleContext } from '../../FormBuilder/FormBuilder.types';
import { ProPasswordResetRequestFormProps } from './ProPasswordResetRequestForm.types';

const serviceOSApiClient = new ServiceOSApiClient();

export const ProPasswordResetRequestForm = (props: ProPasswordResetRequestFormProps) => {
  const { blok } = props;
  const { form } = blok;

  if (!form.length) {
    return null;
  }

  const handleSubmit = async (data: JsonObject, context: FormBuilderRequestLifecycleContext) => {
    const { successMessage, errorMessage } = await serviceOSApiClient.requestResetPassword(
      data.email as string
    );

    if (errorMessage) {
      context.setErrorMessage(errorMessage);
    } else if (successMessage) {
      context.setSuccessMessage(successMessage);
    }
  };

  const formBuilderBlok = {
    ...form[0],
    submitDataAs: 'json',
  };

  return (
    <StoryblokComponent blok={formBuilderBlok} key={formBuilderBlok._uid} onSubmit={handleSubmit} />
  );
};
